import styled from 'styled-components';
import { Input, Select, Button, Card, InputNumber, Divider, Form } from 'antd';
import { COLORS } from '../../../constants/colors';

export const Container = styled.div`
  background-color: transparent;
  min-height: 100%;
`;

export const HeaderContainer = styled.div`
  margin-bottom: 24px;
`;

export const FormCard = styled(Card)`
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  
  &:hover {
    transform: none !important;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
  }

  @media (max-width: 576px) {
    border-radius: 6px;

    .ant-card-body {
      padding: 12px;
    }
  }
`;

export const BackButton = styled.div`
  font-size: 16px;
  color: ${COLORS.$primaryBlue || '#1890ff'};
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: underline;
  text-underline-offset: 4px;
  
  &:hover {
    color: ${COLORS.$secondaryBlue || '#40a9ff'};
    text-decoration: underline;
  }
  
  .anticon {
    font-size: 14px;
  }
`;

export const SaveButton = styled(Button)`
  background: linear-gradient(135deg, ${COLORS.$primaryBlue || '#1890ff'} 0%, ${COLORS.$secondaryBlue || '#40a9ff'} 100%);
  border: none;
  min-width: 140px;
  height: 52px;
  box-shadow: none !important;

  @media (max-width: 576px) {
    min-width: 100px;
    height: 44px;
    font-size: 14px;
  }
  transition: background .25s ease, color .25s ease, opacity .25s ease;

  &:hover, &:focus {
    background: linear-gradient(135deg, ${COLORS.$secondaryBlue || '#40a9ff'} 0%, ${COLORS.$primaryBlue || '#1890ff'} 100%);
    border: none;
    box-shadow: none !important;
  }
  
  &:active {
    background: linear-gradient(135deg, ${COLORS.$primaryBlue || '#1890ff'} 0%, ${COLORS.$darkBlue || '#096dd9'} 100%);
    border: none;
    box-shadow: none !important;
  }

  &.ant-btn-disabled, &.ant-btn[disabled], &[disabled] {
    background: #d9d9d9 !important;
    color: #666 !important;
    border: none !important;
    box-shadow: none !important;
    cursor: not-allowed;
    opacity: 1; /* ensure consistent gray */
  }
`;

export const StyledInput = styled(Input)`
  height: 52px;
  border-radius: 10px;
  border: 2px solid ${COLORS.border};
  font-size: 16px;
  display: flex;
  align-items: center;

  @media (max-width: 576px) {
    height: 44px;
    font-size: 14px;
  }
  
  .ant-input {
    display: flex;
    align-items: center;
    line-height: 1.2;
  }
  
  &::placeholder {
    line-height: 1.2;
  }
  
  &:focus, &:hover {
    border-color: ${COLORS.$primaryBlue};
  }
`;

export const StyledSelect = styled(Select)`
  .ant-select-selector {
    height: 52px !important;
    border-radius: 10px !important;
    border: 1px solid ${COLORS.border} !important;
    font-size: 16px;
    display: flex !important;
    align-items: center !important;
    
    &:focus, &:hover {
      border-color: ${COLORS.$primaryBlue} !important;
    }
  }
  
  .ant-select-selection-item {
    line-height: 1.2 !important;
    display: flex !important;
    align-items: center !important;
  }
  
  .ant-select-selection-placeholder {
    line-height: 1.2 !important;
    display: flex !important;
    align-items: center !important;
  }

  @media (max-width: 576px) {
    .ant-select-selector {
      height: 44px !important;
      font-size: 14px;
    }
  }
`;

export const StyledInputNumber = styled(InputNumber)`
  width: 100%;
  height: 52px;
  border-radius: 10px;
  border: 2px solid ${COLORS.border};
  font-size: 16px;
  display: flex;
  align-items: center;

  @media (max-width: 576px) {
    height: 44px;
    font-size: 14px;
  }
  
  &:focus, &:hover {
    border-color: ${COLORS.$primaryBlue};
  }
  
  .ant-input-number-input-wrap {
    height: 100%;
    display: flex;
    align-items: center;
  }
  
  .ant-input-number-input {
    text-align: left;
    height: 100%;
    line-height: 1.2;
    display: flex;
    align-items: center;
    
    &::placeholder {
      line-height: 1.2;
      text-align: left;
    }
  }
  
  .ant-input-number-handler-wrap {
    display: flex;
    align-items: center;
  }
`;

export const StyledTextArea = styled(Input.TextArea)`
  border-radius: 10px;
  border: 2px solid ${COLORS.border};
  font-size: 16px;
  
  &.ant-input {
    line-height: 1.4;
  }
  
  &::placeholder {
    line-height: 1.4;
  }
  
  &:focus, &:hover {
    border-color: ${COLORS.$primaryBlue};
  }
`;

export const StyledDatePicker = styled.div`
  .ant-picker {
    width: 100%;
    height: 52px;
    border-radius: 10px;
    border: 2px solid ${COLORS.border};
    font-size: 16px;
    display: flex;
    align-items: center;
    
    .ant-picker-input > input {
      line-height: 1.2;
    }
    
    .ant-picker-input > input::placeholder {
      line-height: 1.2;
    }
    
    &:focus, &:hover {
      border-color: ${COLORS.$primaryBlue};
    }
  }

  @media (max-width: 576px) {
    .ant-picker {
      height: 44px;
      font-size: 14px;
    }
  }
`;

export const SectionCard = styled(Card)`
  margin-bottom: 16px;
  
  .ant-card-head-title {
    font-weight: 600;
    color: ${COLORS.textDark};
  }
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SectionTitle = styled.h4`
  color: ${COLORS.textDark};
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  
  .anticon {
    margin-right: 8px;
  }
`;

export const FormSection = styled.div`
  margin-bottom: 32px;

  @media (max-width: 576px) {
    margin-bottom: 20px;
  }
`;

export const DividerWithText = styled.div`
  margin: 32px 0 24px;
  
  .ant-divider-inner-text {
    color: ${COLORS.textDark};
    font-size: 16px;
  }
`;

export const HeaderWrapper = styled.div`
  border-bottom: 1px solid ${COLORS.border || '#e0e0e0'};
  padding-bottom: 24px;
  margin-bottom: 20px;
  
  /* Full-width border extending to edges */
  margin-left: -24px;
  margin-right: -24px;
  padding-left: 24px;
  padding-right: 24px;
  
  @media (max-width: 768px) {
    margin-left: -20px;
    margin-right: -20px;
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const HeaderTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 576px) {
    margin-bottom: 12px;
  }
`;

export const PatientIdBadge = styled.div`
  background-color: ${COLORS.$primaryBlue || '#1890ff'};
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
`;

export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MainTitle = styled.h2`
  margin: 0;
  color: ${COLORS.textDark};
  font-size: 28px;
  font-weight: 600;
  letter-spacing: -0.5px;

  @media (max-width: 576px) {
    font-size: 22px;
  }
`;

export const PatientNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 576px) {
    gap: 8px;
  }
`;

export const PatientName = styled.span`
  color: ${COLORS.textMedium};
  font-size: 16px;
  line-height: 1.5;
  font-weight: 500;
`;

// Thin vertical divider between name and inline ID
export const NameDivider = styled.span`
  display: inline-block;
  width: 1px;
  height: 18px;
  background: ${COLORS.border};
  margin: 0 4px;
`;

export const PatientInlineId = styled.span`
  font-size: 13px;
  letter-spacing: 0.5px;
  color: ${COLORS.textSecondary};
  background: #fafafa;
  border: 1px solid ${COLORS.border};
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  line-height: 1;
`;

export const StatusBadge = styled.div`
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
  background-color: ${props => 
    props.status === 'completed' ? '#f6ffed' :
    props.status === 'in_progress' ? '#fff7e6' :
    props.status === 'new' ? '#e6f7ff' : '#f5f5f5'
  };
  color: ${props =>
    props.status === 'completed' ? '#52c41a' :
    props.status === 'in_progress' ? '#fa8c16' :
    props.status === 'new' ? '#1890ff' : '#8c8c8c'
  };
  border: 1px solid ${props =>
    props.status === 'completed' ? '#b7eb8f' :
    props.status === 'in_progress' ? '#ffd591' :
    props.status === 'new' ? '#91d5ff' : '#d9d9d9'
  };
`;

// Risk score badge with color based on risk level
const getRiskColor = (level) => {
  switch(level) {
    case 'critical': return { bg: '#fff1f0', color: '#cf1322', border: '#ffa39e' };
    case 'high': return { bg: '#fff2e8', color: '#d4380d', border: '#ffbb96' };
    case 'medium': return { bg: '#fffbe6', color: '#d48806', border: '#ffe58f' };
    case 'low': return { bg: '#f6ffed', color: '#389e0d', border: '#b7eb8f' };
    case 'minimal': return { bg: '#e6fffb', color: '#08979c', border: '#87e8de' };
    default: return { bg: '#f5f5f5', color: '#8c8c8c', border: '#d9d9d9' };
  }
};

export const RiskScoreBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 600;
  background-color: ${props => getRiskColor(props.level).bg};
  color: ${props => getRiskColor(props.level).color};
  border: 2px solid ${props => getRiskColor(props.level).border};
  margin-left: 8px;
  cursor: default;
  
  &:hover {
    transform: scale(1.05);
    transition: transform 0.2s ease;
  }
`;

export const SubtitleText = styled.span`
  color: ${COLORS.textMedium};
  font-size: 14px;
  margin-top: 4px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 400px;
`;

export const LoadingText = styled.span`
  margin-top: 16px;
  color: ${COLORS.textSecondary};
`;

// Custom scrollable pill tab container (replaces Ant Design Tabs for reliable mobile scrolling)
export const EditTabsContainer = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 6px;
  padding: 8px 0 4px;
  margin-bottom: 4px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar { display: none; }
`;

export const EditTabButton = styled.button.attrs({ type: 'button' })`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: ${props => props.$active ? '600' : '500'};
  color: ${props => props.$active ? COLORS.$primaryBlue : COLORS.textMedium};
  background: ${props => props.$active ? '#eef4ff' : 'transparent'};
  box-shadow: ${props => props.$active ? '0 1px 3px rgba(0,0,0,.06)' : 'none'};
  white-space: nowrap;
  transition: all 0.2s ease;
  flex-shrink: 0;

  .anticon {
    font-size: 16px;
  }

  .svg-inline--fa {
    font-size: 14px;
    width: 1em;
    opacity: ${props => props.$active ? 1 : 0.75};
  }

  &:hover {
    color: ${COLORS.textDark};
    background: ${props => props.$active ? '#eef4ff' : 'rgba(24,144,255,0.08)'};
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.$primaryBlue};
    outline-offset: 2px;
  }

  @media (max-width: 576px) {
    padding: 8px 12px;
    font-size: 13px;
    gap: 6px;
  }
`;

export const TabIcon = styled.span`
  margin-right: 8px;
`;

export const FormDivider = styled(Divider)`
  margin: 32px 0 24px;
`;

export const FormFooter = styled(Form.Item)`
  margin-bottom: 0;
  text-align: right;
`;

export const StyledIcon = styled.span`
  color: ${COLORS.textMuted};
  display: flex;
  align-items: center;
`;

export const ZipCodeInput = styled(StyledInput)`
  width: 100%;
  max-width: 300px;
`;

export const DividerText = styled.span`
  color: ${COLORS.textDark};
  font-size: 16px;
`;
